import { useState } from "react";

// components
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import KBFileList from "./components/KBFileList";
import AddKBFile from "./components/AddKBFile";

const KnowledgeBase = ()=>{
    const [showForm, setShowForm] = useState(false);
    const [reloadList, setReloadList] = useState(false)

    const handleKBFileCreated = ()=>{
        setReloadList(prevState => !prevState);
        setShowForm(false);
    }

    return (
        <div>
            <h1>Knowledge Base</h1>
            <div className="template__Wrapper">
                <KBFileList reloadList={reloadList}/>
                <Button onClick={() => setShowForm(true)} style={{marginBottom:'2rem'}}> 
                    Aggiungi file
                </Button>
                <Dialog
                    header="Aggiungi File"
                    visible={showForm}
                    style={{ width: '50vw' }} 
                    modal
                    onHide={() => setShowForm(false)}
                >
                    <AddKBFile onKBFileCreated={handleKBFileCreated}  /> 
                </Dialog>
            </div>
        </div>
    )
}

export default KnowledgeBase